/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowcaseEntry
 */
export interface ShowcaseEntry {
    /**
     * 
     * @type {string}
     * @memberof ShowcaseEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowcaseEntry
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ShowcaseEntry
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof ShowcaseEntry
     */
    submittedAt: number;
    /**
     * 
     * @type {number}
     * @memberof ShowcaseEntry
     */
    voteCount: number;
}

/**
 * Check if a given object implements the ShowcaseEntry interface.
 */
export function instanceOfShowcaseEntry(value: object): value is ShowcaseEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('submittedAt' in value) || value['submittedAt'] === undefined) return false;
    if (!('voteCount' in value) || value['voteCount'] === undefined) return false;
    return true;
}

export function ShowcaseEntryFromJSON(json: any): ShowcaseEntry {
    return ShowcaseEntryFromJSONTyped(json, false);
}

export function ShowcaseEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowcaseEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'userId': json['userId'],
        'content': json['content'],
        'submittedAt': json['submittedAt'],
        'voteCount': json['voteCount'],
    };
}

export function ShowcaseEntryToJSON(json: any): ShowcaseEntry {
    return ShowcaseEntryToJSONTyped(json, false);
}

export function ShowcaseEntryToJSONTyped(value?: ShowcaseEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'content': value['content'],
        'submittedAt': value['submittedAt'],
        'voteCount': value['voteCount'],
    };
}

